import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { GetWindowState, } from "../../Utils";
import { translate } from "react-i18nify";
import { colors } from "../../Style";
import { DownArrow, UpArrow } from "../UI/Arrows";



const generateMenuItems = (state) => {
		//Change these values for screenshots showing the different states
    return [
        {
            label: translate("ValueSeconds", { value: "60" }),
            value: 60
        },
        {
            label: translate("ValueSeconds", { value: "30" }),
            value: 30
            
        },
        {
            label: translate("ValueSeconds", { value: "15" }),	
            value: 15
        },
        {
            label: translate("ValueSeconds", { value: "10" }),
            value: 10
        },
        {
            label: translate("ValueSeconds", { value: "4" }),
            value: 4
        },
    ];
}

export const SampleRate = (props) => {
		const state = GetWindowState();

	const menuItems = generateMenuItems(state)

	const navigation = (navigatior, action, menu, state) => {
			if(action.type === "CLICK"){
				switch(menu[action.button].route){
			case "NAVIGATE_CANCEL":
				props.onCancel();
				break;
			case "NAVIGATE_BACK":
				props.onCancel();
				break;
			case "NAVIGATE_SELECT":
				selectClicked(state)
				break;
			case "NAVIGATE_UP":
				valueUp(state);
				break;
			case "NAVIGATE_DOWN":
				valueDown(state);
				break;
				}
			}
		}

	
    const getIndexOfValue = (value) => {
        let newIndex = 0;
        menuItems.map((obj, index) => {
            if(obj.value === value){
                newIndex = index 
            }
        })
        return newIndex
    }

	const startActiveItemIndex = getIndexOfValue(props.value)

	const defaultState = {
		name: props.name,
        menuItems: menuItems,
		value: props.value,
		activeItemIndex: startActiveItemIndex,
		label: props.label,
		windowNavigation: navigation,
		};

	const menu = props.menu ? 
		props.menu
		: {
			LEFT: { label: "Back", route: "NAVIGATE_BACK", local: true },
			UP: startActiveItemIndex <= 0 ? null : { label: "UP", route: "NAVIGATE_UP", local: true },
			RIGHT: { label: "Select", route: "NAVIGATE_SELECT", local: true },
			MIDDLE: null,
			DOWN: startActiveItemIndex >= menuItems.length - 1 ? null : { label: "DOWN", route: "NAVIGATE_DOWN", local: true },
		};

	const windowState = props?.state ? 	
		{
			...props.state,
			menu: menu,
			label: props.label,
		}
		: defaultState;

	useEffect(() => {
		windowState.windowNavigation = navigation;
		props.setState(menu, windowState);
	}, [windowState.name]);

	const setWindowState = (windowState) => {
		props.setState(windowState.menu, windowState);
	};


	const selectClicked = (state) => {
		props.onComplete(menuItems[state.activeItemIndex].value);
	}

	const valueUp = (state) => {
		let prevIndex = state.activeItemIndex;
		let newActiveIndex = prevIndex > 0 ? prevIndex - 1 : prevIndex;
		let newState = { ...state, activeItemIndex: newActiveIndex };
		setWindowState({
			...state,
			activeItemIndex: newActiveIndex,
			menu: updateNavigation(newState),
		});
	
	};

	const valueDown = (state) => {
		let prevIndex = state.activeItemIndex;
		let menuItems = state.menuItems;
		let newActiveIndex =
			prevIndex < menuItems.length - 1 ? prevIndex + 1 : prevIndex;
		let newState = { ...state, activeItemIndex: newActiveIndex };
		setWindowState({
			...state,
			activeItemIndex: newActiveIndex,
			menu: updateNavigation(newState),
		});
	};

	
	const updateNavigation = (state) => {
		let menu = {
			LEFT: { label: "Back", route: "NAVIGATE_CANCEL", local: true },
			RIGHT: { label: "Select", route: "NAVIGATE_SELECT", local: true },
		};
		const showUpButton = state.activeItemIndex > 0;
		const showDownButton = state.activeItemIndex < state.menuItems.length - 1;
		menu.UP = showUpButton
			? { label: "UP", route: "NAVIGATE_UP", local: true }
			: null;
		menu.DOWN = showDownButton
			? { label: "DOWN", route: "NAVIGATE_DOWN", local: true }
			: null;
		return menu;
	};

	const arrowMargin = { left: "47%", top: "10px", bottom: "10px" };

	return (
		<Box
			sx={{
				width: "475px",
				height: "210px",
				background: "black",
				border: "1px solid white",
				p: 1,
				pl: 2,
				pr: 2,
			}}
		>
			<Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
				<Typography
					variant="h6"
					sx={{ color: colors().TEXT_COLOR, fontWeight: "bold" }}
				>
					{translate(windowState?.label)}
				</Typography>
			</Box>
			<Box sx={{display: "absolute", width:"100%", marginTop: "10px" }} > {/*  marginLeft: "43%", */}
				<Typography
					variant="h7"
					sx={{ color: colors().COLORS_SUBITEM_DEFAULT, fontWeight: "bold", marginLeft:"46%" }}
				>
					{windowState.menuItems[windowState.activeItemIndex - 1 > windowState.menuItems.length ? "" : windowState.activeItemIndex - 1]?.label}
				</Typography>
				<Box  sx={{display: "absolute",  marginLeft: "10px" }}>
						{
                            windowState.activeItemIndex - 1 < 0 ?
                            <></>
                            :
                            <UpArrow sx={{ marginLeft: arrowMargin.left, height: "20px", }} />
						}
					<Typography
						variant="h5"
						sx={{ color: colors().TEXT_COLOR, fontWeight: "bold", marginLeft:"42%", height: "35px" }}
					>
						{windowState.menuItems[windowState.activeItemIndex].label}
					</Typography>     
                    {
                        windowState.activeItemIndex + 1 > windowState.menuItems.length - 1  ?
                        <></>
                    :
                        <DownArrow sx={{ marginLeft: arrowMargin.left, height: "20px" }} />
                    }
					
				</Box>        
				<Typography
					variant="h7"
					sx={{ color: colors().COLORS_SUBITEM_DEFAULT, fontWeight: "bold", marginLeft: windowState.activeItemIndex + 1 > windowState.menuItems.length - 1 ? "47" : "46%" }}
				>
					{windowState.menuItems[windowState.activeItemIndex + 1 < 0 ? "" : windowState.activeItemIndex + 1 ]?.label}
				</Typography>     
			</Box>
		</Box>
	);
}
				
